import * as React from "react";
type Props = {
  className?: string,
};
function SvgLowFat({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-LowFat"
      className={className}
    >
      <path
        d="M29.4071 3L29.407 19.7935M34.445 14.9585L29.4342 20.4798L24.3687 14.8982M12.5373 30.666C10.6024 29.3929 9.73743 27.0979 10.374 24.9256M24.5602 26.6351C24.5602 28.8779 23.744 31.0849 22.19 32.8087L22.0528 32.9589C18.393 37.0137 12.0301 37.0137 8.37353 32.9589C6.81619 31.2319 6 29.0249 6 26.7852C6 25.5805 6.23832 24.366 6.72152 23.2136C6.77375 23.0896 6.83251 22.9557 6.8978 22.8153C7.29281 21.9566 7.91972 20.7651 8.65746 19.4297C9.4215 18.052 10.3062 16.5176 11.1713 15.0387C11.2922 14.833 11.413 14.6273 11.5338 14.4249C11.8962 13.8045 12.2553 13.2038 12.598 12.6325C12.6601 12.5248 12.7254 12.4203 12.7874 12.3158C14.1783 9.98483 15.2458 8.24789 15.2458 8.24789C15.2458 8.24789 16.1665 9.6942 17.4168 11.7216C19.6957 15.4206 23.0714 21.0491 23.9496 23.3344C24.361 24.4052 24.5602 25.525 24.5602 26.6351Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgLowFat;
